import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Container, Image, Button } from 'react-bootstrap'

import Breadcrumbs from './../block/Breadcrumbs'
import FAQSection from './../block/FAQSection'
import FeedbackForm from './../block/FeedbackForm'

import styles from './../style/DeliveryPage.module.scss';

export default class Delivery extends Component {

  constructor(props) {
    super(props)

    this.state = {
      show_feedback: false
    }
  }

  set_feedback = ( stat ) => {
    this.setState({
      show_feedback: stat
    })
  }

  render() {

    const { ajax_data, user_profile_type } = this.props,
    { show_feedback } = this.state

    if(user_profile_type == `legal`) return (
      <>
        <Breadcrumbs items={ajax_data.breadcrumbs} />
        <section className={styles.section}>
          <Container className={styles.container}>
            <h1>Доставка заказов юридическим лицам </h1>
            <p>При оформлении заказа наш менеджер предоставит вам полную информацию о сроках, стоимости и условиях доставки в ваш регион. После подтверждения покупки мы организуем отправку в соответствии с вашими предпочтениями.</p>
            <p>Мы сотрудничаем с ведущими транспортными компаниями России, что позволяет нам обеспечить надежную и быструю доставку.</p>

            <div className={styles.images}>

              <div style={{ width: `100%` }} className={styles.seriyblok}>
                <div className={styles.seriyblok_h}>
                  <div>Доставка транспортной компанией</div>
                  <Image src="/images/delivery/transportc2.png" width={29} height={29} alt={`Т.ком.`} />
                </div>
                <div className={styles.seriyblok_witems}>
                  <div style={{ width: `560px` }} className={styles.seriyblok_witems_el}>
                    <div className={styles.seriyblok_witems_el_3_iconblock}>
                      <Image src="/images/delivery/geogr.svg" width={24} height={24} alt={`Гео`} />
                      <div>
                        <div className={styles.seriyblok_witems_el_title}>География доставки</div>
                        <div>Доставка осуществляется по всей территории России и ближнего зарубежья.</div>
                      </div>
                    </div>
                    <div className={styles.seriyblok_witems_el_sep}></div>
                    <div className={styles.seriyblok_witems_el_3_iconblock}>
                      <Image src="/images/delivery/calculator.svg" width={24} height={24} alt={`Калькулятор`} />
                      <div>
                        <div>Для расчета точной стоимости доставки вы можете воспользоваться калькулятором на официальном сайте грузоперевозчика.</div>
                      </div>
                    </div>
                  </div>
                  <div style={{ width: `595px` }} className={styles.seriyblok_witems_el}>
                    <div className={styles.seriyblok_witems_el_3_iconblock}>
                      <Image src="/images/delivery/carb.svg" width={24} height={24} alt={`Авто`} />
                      <div>
                        <div className={styles.seriyblok_witems_el_title}>Экспресс-доставка</div>
                        <div>Небольшие посылки <font color="black">(до 30 кг)</font> мы в основном отправляем экспресс-доставкой через ТК СДЭК, так как пункт выдачи заказов (ПВЗ) находится в нашем здании склада, по адресу: г. Нижний Новгород, улица Белинского, д. 32</div>
                      </div>
                    </div>
                    <div className={styles.seriyblok_witems_el_3_iconblock + ` align-items-center mt-2`}>
                      <Image src="/images/delivery/info-circle.svg" width={24} height={24} alt={`Инфо`} />
                      <div>
                        <div>Доставка до ПВЗ СДЭК — бесплатно.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div className={styles.images}>

              <div style={{ width: `529px` }} className={styles.seriyblok}>
                <div className={styles.seriyblok_h}>
                  <div>Самовывоз</div>
                  <div className={styles.blue_plashka}>
                    <div className={styles.blue_plashka_icon}>
                      <Image src="/images/delivery/car.svg" width={20} height={20} alt={`А`} />
                    </div>
                    <div>Магазин StomaHelp</div>
                  </div>
                </div>
                <div className={styles.seriyblok_witems}>
                  <div style={{ width: `100%` }} className={styles.seriyblok_witems_el}>
                    <div className={styles.seriyblok_witems_el_3_iconblock}>
                      <Image src="/images/delivery/routing.svg" width={24} height={24} alt={`Гео`} />
                      <div>
                        <div className={styles.seriyblok_witems_el_title}>603000, г. Нижний Новгород, ул. Белинского, дом 32, офис 40</div>
                        <div>Вы также можете самостоятельно забрать товар по адресу</div>
                      </div>
                    </div>
                    <div className={styles.seriyblok_witems_el_sep}></div>
                    <div className={styles.seriyblok_witems_el_3_iconblock}>
                      <Image src="/images/delivery/route-square.svg" width={24} height={24} alt={`Гео`} />
                      <div>
                        <div>Для удобства используйте навигатор, введя <font color="black">«Стомахелп»</font>, чтобы добраться до нужного входа.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ width: `666px` }} className={styles.seriyblok}>
                <div className={styles.seriyblok_h}>
                  <div className='d-flex align-items-center'>
                    <Image src="/images/delivery/info-circle.svg" width={24} height={24} alt={`Инфо`} />
                    <div className='ms-2'>Важная информация</div>
                  </div>
                  <div className={styles.seriyblok_h_rtext}>Минимальная сумма заказа доставки — отсутствует</div>
                </div>
                <div className={styles.seriyblok_witems}>
                  <div style={{ width: `100%` }} className={styles.seriyblok_witems_el}>
                    <div className={styles.seriyblok_witems_el_3_iconblock}>
                      <Image src="/images/delivery/receipt-item.svg" width={23} height={24} alt={`Чек`} />
                      <div>
                        <div className={styles.seriyblok_witems_el_title}>Стоимость доставки оплачивается покупателем</div>
                        <div>Вы можете выбрать оплату доставки отдельно или включить её в счет на оплату.</div>
                      </div>
                    </div>
                    <div className={styles.seriyblok_witems_el_sep}></div>
                    <div className={styles.seriyblok_witems_el_3_iconblock}>
                      <Image src="/images/delivery/box.svg" width={24} height={24} alt={`Бокс`} />
                      <div>
                        <div className={styles.seriyblok_witems_el_title}>Отгрузка товара</div>
                        <div>Осуществляется после поступления денежных средств на расчетный счет продавца. Мы готовы отгрузить ваш заказ в день поступления средств.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div className={styles.alert}>
              <svg style={{ flex: 'none' }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.0003 18.3327C14.5837 18.3327 18.3337 14.5827 18.3337 9.99935C18.3337 5.41602 14.5837 1.66602 10.0003 1.66602C5.41699 1.66602 1.66699 5.41602 1.66699 9.99935C1.66699 14.5827 5.41699 18.3327 10.0003 18.3327Z" stroke="#E34148" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10 6.66699V10.8337" stroke="#E34148" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.99512 13.333H10.0026" stroke="#E34148" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div>Если у вас есть дополнительные вопросы или вам нужна помощь, не стесняйтесь обращаться к специалистам нашего отдела продаж — они помогут подобрать оптимальный вариант доставки именно для вас.</div>
            </div>

            <div className={styles.bluline}>
              <div>
                <div className={styles.bluline_title}>Хотите убедиться сами?</div>
                <div className={styles.bluline_text}>Закажите уже сегодня и убедитесь в том, что заботиться о своем комфорте так просто!</div>
              </div>
              <div className={styles.bluline_btn + ' d-flex align-items-center'}>
                <div className={styles.bluline_btntext}>Забота начинается здесь</div>
                <Button onClick={() => this.set_feedback(true)} variant="light">Связаться с нами</Button>
                <FeedbackForm
                  title={`Нужна консультация?`}
                  text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
                  btn={`Отправить`}
                  data={[]}
                  show={show_feedback}
                  handleClose={() => this.set_feedback(false)}
                />
              </div>
            </div>
 
            <h2>Оплата</h2>
            <p>Мы предлагаем несколько удобных способов оплаты:</p>

            <div className={styles.images}>

              <div style={{ width: `100%` }} className={styles.seriyblok}>
                <div className={styles.seriyblok_witems}>
                  <div style={{ width: `387px` }} className={styles.seriyblok_witems_el}>
                    <div className={styles.seriyblok_witems_el_3_iconblock + ` align-items-center`}>
                      <Image src="/images/delivery/card.svg" width={24} height={24} alt={`Карт.`} />
                      <div>
                        <div className={styles.seriyblok_witems_el_title}>Безналичный расчет</div>
                      </div>
                    </div>
                    <div className={styles.seriyblok_witems_el_sep}></div>
                    <div className={styles.seriyblok_witems_el_3_iconblock}>
                      <div>
                        <div>Для юридических лиц и ИП. Выставляем счет, предоставляем закрывающие документы</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

          </Container>
        </section>
        <FAQSection
          qwestions={user_profile_type == `legal` ? ( ajax_data?.qwestions_ng_legal || [] ) : ( ajax_data?.qwestions_ng || [] )}
        />
      </>
    )

    return (
      <>
        <Breadcrumbs items={ajax_data.breadcrumbs} />
        <section className={styles.section}>
          <Container className={styles.container}>
            <h1>Доставка заказов физическим лицам</h1>
            <p>Мы понимаем, как важно получить нужное техническое средство реабилитации вовремя и без лишних хлопот. Именно поэтому мы предлагаем удобную и быструю доставку товаров прямо вам домой или в любое удобное место</p>
            <div>
              <div style={{ width: `100%`, marginBottom: `10px`, marginTop: `10px` }} className={styles.seriyblok}>
                <div className={`${styles.seriyblok_h} ${styles.seriyblok_h_2line}`}>
                  <div className='d-flex align-items-center'>
                    <svg className='me-2' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15 2V12C15 13.1 14.1 14 13 14H2V6C2 3.79 3.79 2 6 2H15Z" stroke="#1E9FF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M22 14V17C22 18.66 20.66 20 19 20H18C18 18.9 17.1 18 16 18C14.9 18 14 18.9 14 20H10C10 18.9 9.1 18 8 18C6.9 18 6 18.9 6 20H5C3.34 20 2 18.66 2 17V14H13C14.1 14 15 13.1 15 12V5H16.84C17.56 5 18.22 5.39001 18.58 6.01001L20.29 9H19C18.45 9 18 9.45 18 10V13C18 13.55 18.45 14 19 14H22Z" stroke="#1E9FF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M8 22C9.10457 22 10 21.1046 10 20C10 18.8954 9.10457 18 8 18C6.89543 18 6 18.8954 6 20C6 21.1046 6.89543 22 8 22Z" stroke="#1E9FF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M16 22C17.1046 22 18 21.1046 18 20C18 18.8954 17.1046 18 16 18C14.8954 18 14 18.8954 14 20C14 21.1046 14.8954 22 16 22Z" stroke="#1E9FF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M22 12V14H19C18.45 14 18 13.55 18 13V10C18 9.45 18.45 9 19 9H20.29L22 12Z" stroke="#1E9FF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <div>Как это работает?</div>
                  </div>
                  <div className={styles.blue_plashka}>
                    <div className={styles.blue_plashka_icon}>
                      <Image src="/images/delivery/car.svg" width={20} height={20} alt={`А`} />
                    </div>
                    <div>Гибкие логистические условия в любою точку страны</div>
                  </div>
                </div>
                <div className={styles.seriyblok_witems_u}>
                  <div className={styles.seriyblok_witems_el_u1}>
                    <div className={styles.seriyblok_witems_el_title + ` justify-content-between mb-2`}>
                      <div>Выберите<br className='d-none d-md-inline' />товар</div>
                      <svg className='d-none d-md-block' style={{ flex: 'none' }} width="45" height="21" viewBox="0 0 45 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M39.166 18.0827H30.8327C28.3327 18.0827 26.666 16.8327 26.666 13.916V8.08268C26.666 5.16602 28.3327 3.91602 30.8327 3.91602H39.166C41.666 3.91602 43.3327 5.16602 43.3327 8.08268V13.916C43.3327 16.8327 41.666 18.0827 39.166 18.0827Z" stroke="#1E9FF6" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M30 7.66602V14.3327" stroke="#1E9FF6" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M32.5 7.66602V10.9993" stroke="#1E9FF6" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M32.5 13.5V14.3333" stroke="#1E9FF6" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M37.5 7.66602V8.49935" stroke="#1E9FF6" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M35 7.66602V14.3327" stroke="#1E9FF6" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M37.5 11V14.3333" stroke="#1E9FF6" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M40 7.66602V14.3327" stroke="#1E9FF6" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7.34284 1.66602L4.32617 4.69102" stroke="#1E9FF6" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12.6602 1.66602L15.6768 4.69102" stroke="#1E9FF6" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M1.66602 6.54167C1.66602 5 2.49102 4.875 3.51602 4.875H16.4827C17.5077 4.875 18.3327 5 18.3327 6.54167C18.3327 8.33333 17.5077 8.20833 16.4827 8.20833H3.51602C2.49102 8.20833 1.66602 8.33333 1.66602 6.54167Z" stroke="#1E9FF6" stroke-width="1.25"/>
                        <path d="M8.13281 11.666V14.6243" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round"/>
                        <path d="M11.9668 11.666V14.6243" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round"/>
                        <path d="M2.91602 8.33398L4.09102 15.534C4.35768 17.1507 4.99935 18.334 7.38268 18.334H12.4077C14.9993 18.334 15.3827 17.2007 15.6827 15.634L17.0827 8.33398" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round"/>
                      </svg>
                    </div>
                    <div className='w-100 d-flex align-items-center justify-content-between'>
                      <div>на нашем сайте StomaHelp</div>
                      <svg style={{ flex: `none` }} className='d-md-none' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.60758 1.5L3.89258 4.2225" stroke="#1E9FF6" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M11.3926 1.5L14.1076 4.2225" stroke="#1E9FF6" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M1.5 5.88672C1.5 4.49922 2.2425 4.38672 3.165 4.38672H14.835C15.7575 4.38672 16.5 4.49922 16.5 5.88672C16.5 7.49922 15.7575 7.38672 14.835 7.38672H3.165C2.2425 7.38672 1.5 7.49922 1.5 5.88672Z" stroke="#1E9FF6" stroke-width="1.25"/>
                        <path d="M7.32031 10.5V13.1625" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round"/>
                        <path d="M10.7695 10.5V13.1625" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round"/>
                        <path d="M2.625 7.5L3.6825 13.98C3.9225 15.435 4.5 16.5 6.645 16.5H11.1675C13.5 16.5 13.845 15.48 14.115 14.07L15.375 7.5" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round"/>
                      </svg>
                    </div>
                  </div>
                  <div className={styles.seriyblok_witems_el_u2}>
                    <div className={styles.seriyblok_witems_el_title + ` mb-2`}>Оформите заказ</div>
                    <div>через корзину или позвоните нам напрямую менеджеру</div>
                  </div>
                  <div className={styles.seriyblok_witems_el_u3}>
                    <div className={styles.seriyblok_witems_el_title + ` mb-2`}>Укажите способ доставки</div>
                    <div>до пункта выдачи заказов, курьерская доставка или самовывоз</div>
                  </div>
                  <div className={styles.seriyblok_witems_el_u4}>
                    <div className='d-flex align-items-center justify-content-between'>
                      <div>
                        <div className={styles.seriyblok_witems_el_title + ` mb-2`}>
                          <div>Получите ваш заказ</div>
                        </div>
                        <div>в оговоренные сроки. Доверьтесь Stomahelp, мы заботимся о вашем времени и комфорте</div>
                      </div>
                      <svg style={{ flex: 'none' }} className='ms-2' width="22" height="53" viewBox="0 0 22 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.3353 12.5C19.3353 15.725 16.727 18.3333 13.502 18.3333L14.377 16.875" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M2.66797 7.5013C2.66797 4.2763 5.2763 1.66797 8.5013 1.66797L7.6263 3.1263" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12.416 3.71094L15.7327 5.62759L19.016 3.71928" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M15.7324 9.01915V5.61914" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14.95 1.84297L12.95 2.95127C12.5 3.20127 12.125 3.83459 12.125 4.35126V6.46796C12.125 6.98463 12.4917 7.61795 12.95 7.86795L14.95 8.9763C15.375 9.21797 16.075 9.21797 16.5083 8.9763L18.5083 7.86795C18.9583 7.61795 19.3333 6.98463 19.3333 6.46796V4.35126C19.3333 3.83459 18.9667 3.20127 18.5083 2.95127L16.5083 1.84297C16.0833 1.60964 15.3833 1.60964 14.95 1.84297Z" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M2.96094 12.873L6.26927 14.7897L9.56094 12.8814" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6.26953 18.1813V14.7812" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5.49297 11.007L3.49297 12.1153C3.04297 12.3653 2.66797 12.9987 2.66797 13.5153V15.632C2.66797 16.1487 3.03464 16.782 3.49297 17.032L5.49297 18.1404C5.91797 18.382 6.61796 18.382 7.0513 18.1404L9.0513 17.032C9.5013 16.782 9.8763 16.1487 9.8763 15.632V13.5153C9.8763 12.9987 9.50964 12.3653 9.0513 12.1153L7.0513 11.007C6.61796 10.7737 5.91797 10.7737 5.49297 11.007Z" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M21 42C21 45 19.675 47.675 17.6 49.5C15.825 51.05 13.525 52 11 52C5.475 52 1 47.525 1 42C1 38.85 2.45 36.025 4.75 34.2C6.475 32.825 8.65 32 11 32C16.525 32 21 36.475 21 42Z" stroke="#1E9FF6" stroke-width="1.3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M11.625 38.875V42.625L8.5 44.5" stroke="#1E9FF6" stroke-width="1.3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ width: `100%`, marginBottom: `10px` }} className={styles.seriyblok}>
                <div className='d-flex align-items-center justify-content-between mb-2'>
                  <div className={styles.seriyblok_h + ` mb-0`}>
                    <div className='d-flex align-items-center'>
                      <svg className='me-2' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.16992 7.43945L11.9999 12.5494L20.7699 7.46942" stroke="#1E9FF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 21.6091V12.5391" stroke="#1E9FF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M9.9306 2.48L4.59061 5.45003C3.38061 6.12003 2.39062 7.80001 2.39062 9.18001V14.83C2.39062 16.21 3.38061 17.89 4.59061 18.56L9.9306 21.53C11.0706 22.16 12.9406 22.16 14.0806 21.53L19.4206 18.56C20.6306 17.89 21.6206 16.21 21.6206 14.83V9.18001C21.6206 7.80001 20.6306 6.12003 19.4206 5.45003L14.0806 2.48C12.9306 1.84 11.0706 1.84 9.9306 2.48Z" stroke="#1E9FF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16.9998 13.2396V9.57965L7.50977 4.09961" stroke="#1E9FF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <div>Почему стоит выбрать нашу доставку?</div>
                    </div>
                  </div>
                  <div className={styles.seriyblok_btext + ` d-none d-md-flex mt-0`}>
                    <Image src="/images/delivery/mobile.svg" width={19} height={23} alt={`Плашет`} />
                    <div>Возможность отслеживать статус заказа — онлайн</div>
                  </div>
                </div>

                <div className={`${styles.seriyblok_witems} ${styles.seriyblok_witems_delivery}`}>
                  <div className={styles.seriyblok_witems}>
                    <div className={styles.seriyblok_witems_el_fw}>
                      <div style={{ width: `calc(50% - 21px)`, flex: `none` }}>
                        <div className={styles.seriyblok_witems_el_title + ` mb-2`}>Бесплатная доставка</div>
                        <div>при заказе от 5000 ₽</div>
                      </div>
                      <div className={styles.seriyblok_witems_el_fw_right}>
                        <div>
                          <div className={styles.seriyblok_witems_el_title + ` mb-2`}>Нижний Новгород</div>
                          <div>Бор, Кстово и Арзамас</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.seriyblok_witems_el}>
                    <div className={styles.seriyblok_witems_el_fw_right + ` d-flex align-items-center justify-content-between`}>
                      <div>
                        <div className={styles.seriyblok_witems_el_title + ` mb-2`}>Быстрая обработка</div>
                        <div>заказов и оперативность выполнения</div>
                      </div>
                      <svg style={{ flex: `none` }} className='ms-2' width="20" height="48" viewBox="0 0 20 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.64062 34.1992L9.99895 38.4575L17.3073 34.2242" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M10 46.0076V38.4492" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18.0088 38.691V35.641C18.0088 34.491 17.1838 33.091 16.1755 32.5327L11.7255 30.066C10.7755 29.5327 9.2255 29.5327 8.2755 30.066L3.82551 32.5327C2.81717 33.091 1.99219 34.491 1.99219 35.641V40.3577C1.99219 41.5077 2.81717 42.9077 3.82551 43.466L8.2755 45.9327C8.7505 46.1994 9.37551 46.3327 10.0005 46.3327C10.6255 46.3327 11.2505 46.1994 11.7255 45.9327" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16.0007 45.8334C17.4734 45.8334 18.6673 44.6394 18.6673 43.1667C18.6673 41.6939 17.4734 40.5 16.0007 40.5C14.5279 40.5 13.334 41.6939 13.334 43.1667C13.334 44.6394 14.5279 45.8334 16.0007 45.8334Z" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M19.1673 46.3333L18.334 45.5" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12.1243 18.0577C15.6993 17.116 18.3327 13.866 18.3327 9.99935C18.3327 5.39935 14.6327 1.66602 9.99935 1.66602C4.44102 1.66602 1.66602 6.29935 1.66602 6.29935M1.66602 6.29935V2.49935M1.66602 6.29935H3.34102H5.36602" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M1.66602 10C1.66602 14.6 5.39935 18.3333 9.99935 18.3333" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="3 3"/>
                      </svg>
                    </div>
                  </div>
                  <div className={styles.seriyblok_witems_el}>
                    <div className={styles.seriyblok_witems_el_fw_right + ` d-flex align-items-center justify-content-between`}>
                      <div>
                        <div className={styles.seriyblok_witems_el_title + ` mb-2`}>Надежные курьеры</div>
                        <div>служба с заботой о вашем здоровье</div>
                      </div>
                      <svg style={{ flex: `none` }} className='ms-2' width="20" height="48" viewBox="0 0 20 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.1657 42.9252C19.1823 43.5502 19.0157 44.1419 18.7157 44.6502C18.549 44.9502 18.324 45.2252 18.074 45.4502C17.499 45.9836 16.7407 46.3086 15.899 46.3336C14.6823 46.3586 13.6073 45.7336 13.0157 44.7752C12.699 44.2836 12.5073 43.6919 12.499 43.0669C12.474 42.0169 12.9407 41.0669 13.6907 40.4419C14.2573 39.9752 14.974 39.6836 15.7573 39.6669C17.599 39.6252 19.124 41.0835 19.1657 42.9252Z" stroke="#1E9FF6" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14.5332 43.026L15.3749 43.8259L17.1165 42.1426" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M2.64062 34.1992L9.99895 38.4575L17.3073 34.2242" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M10 46.0076V38.4492" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18.0088 35.641V40.3577C18.0088 40.3994 18.0088 40.4327 18.0005 40.4743C17.4172 39.966 16.6672 39.666 15.8338 39.666C15.0505 39.666 14.3255 39.941 13.7505 40.3994C12.9838 41.0077 12.5005 41.9494 12.5005 42.9994C12.5005 43.6244 12.6755 44.216 12.9838 44.716C13.0588 44.8494 13.1505 44.9744 13.2505 45.091L11.7255 45.9327C10.7755 46.466 9.2255 46.466 8.2755 45.9327L3.82551 43.466C2.81717 42.9077 1.99219 41.5077 1.99219 40.3577V35.641C1.99219 34.491 2.81717 33.091 3.82551 32.5327L8.2755 30.066C9.2255 29.5327 10.7755 29.5327 11.7255 30.066L16.1755 32.5327C17.1838 33.091 18.0088 34.491 18.0088 35.641Z" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M10.0007 9.99935C12.3018 9.99935 14.1673 8.13387 14.1673 5.83268C14.1673 3.5315 12.3018 1.66602 10.0007 1.66602C7.69946 1.66602 5.83398 3.5315 5.83398 5.83268C5.83398 8.13387 7.69946 9.99935 10.0007 9.99935Z" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M17.1585 18.3333C17.1585 15.1083 13.9501 12.5 10.0001 12.5C6.05013 12.5 2.8418 15.1083 2.8418 18.3333" stroke="#1E9FF6" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                  </div>
                </div>

                <div className={styles.seriyblok_btext + ` d-md-none`}>
                  <Image src="/images/delivery/mobile.svg" width={19} height={23} alt={`Плашет`} />
                  <div>Возможность отслеживать статус заказа — онлайн</div>
                </div>
              </div>

            </div>

            <div className={styles.bluline}>
              <div>
                <div className={styles.bluline_title}>Хотите убедиться сами?</div>
                <div className={styles.bluline_text}>Закажите уже сегодня и убедитесь в том, что заботиться о своем комфорте так просто!</div>
              </div>
              <div className={styles.bluline_btn + ' d-flex align-items-center'}>
                <div className={styles.bluline_btntext}>Забота начинается здесь</div>
                <Button onClick={() => this.set_feedback(true)} variant="light">Связаться с нами</Button>
                <FeedbackForm
                  title={`Нужна консультация?`}
                  text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
                  btn={`Отправить`}
                  data={[]}
                  show={show_feedback}
                  handleClose={() => this.set_feedback(false)}
                />
              </div>
            </div>

            <div className={styles.alert}>
              <svg style={{ flex: 'none' }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.0003 18.3327C14.5837 18.3327 18.3337 14.5827 18.3337 9.99935C18.3337 5.41602 14.5837 1.66602 10.0003 1.66602C5.41699 1.66602 1.66699 5.41602 1.66699 9.99935C1.66699 14.5827 5.41699 18.3327 10.0003 18.3327Z" stroke="#E34148" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10 6.66699V10.8337" stroke="#E34148" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.99512 13.333H10.0026" stroke="#E34148" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div>Если у вас есть дополнительные вопросы или вам нужна помощь, не стесняйтесь обращаться к специалистам нашего отдела продаж — они помогут подобрать оптимальный вариант доставки именно для вас.</div>
            </div>
 
            <h2>Оплата</h2>
            <p>Мы предлагаем несколько удобных способов оплаты:</p>

            <div className={styles.images}>

              <div style={{ width: `100%` }} className={styles.seriyblok}>
                <div className={styles.seriyblok_witems}>
                  <div style={{ width: `364px` }} className={styles.seriyblok_witems_el}>
                    <div className={styles.seriyblok_witems_el_3_iconblock + ` align-items-center`}>
                      <Image src="/images/delivery/empty-wallet.svg" width={24} height={24} alt={`Расч.`} />
                      <div>
                        <div className={styles.seriyblok_witems_el_title}>Наличный расчет</div>
                      </div>
                      <Image className='ms-auto' src="/images/delivery/delivery.png" width={55} height={25} alt={`Дост.`} />
                    </div>
                    <div className={styles.seriyblok_witems_el_sep}></div>
                    <div className={styles.seriyblok_witems_el_3_iconblock}>
                      <div>
                        <div>Оплата курьеру при получении заказа или в пункте выдачи CDEK / Почта России</div>
                      </div>
                    </div>
                  </div>
                  <div style={{ width: `395px` }} className={styles.seriyblok_witems_el}>
                    <div className={styles.seriyblok_witems_el_3_iconblock + ` align-items-center`}>
                      <Image src="/images/delivery/receipt-item.svg" width={24} height={24} alt={`Чек`} />
                      <div>
                        <div className={styles.seriyblok_witems_el_title}>Онлайн-оплата картой</div>
                      </div>
                      <Image className='ms-auto' src="/images/delivery/cards.png" width={99} height={20} alt={`Карт.`} />
                    </div>
                    <div className={styles.seriyblok_witems_el_sep}></div>
                    <div className={styles.seriyblok_witems_el_3_iconblock}>
                      <div>
                        <div>Оплата товаров осуществляется через платежный шлюз ПАО Сбербанк</div>
                      </div>
                    </div>
                  </div>
                  <div style={{ width: `385px` }} className={styles.seriyblok_witems_el}>
                    <div className={styles.seriyblok_witems_el_3_iconblock + ` align-items-center`}>
                      <Image src="/images/delivery/card.svg" width={24} height={24} alt={`Чек`} />
                      <div>
                        <div className={styles.seriyblok_witems_el_title}>Электронный сертификат</div>
                      </div>
                    </div>
                    <div className={styles.seriyblok_witems_el_sep}></div>
                    <div className={styles.seriyblok_witems_el_3_iconblock}>
                      <div>
                        <div>Способ получения средств на реабилитацию при помощи оплаты электронным сертификатом (ТСР)</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div className={styles.alert + ' mb-1'}>
              <svg style={{ flex: 'none' }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.0003 18.3327C14.5837 18.3327 18.3337 14.5827 18.3337 9.99935C18.3337 5.41602 14.5837 1.66602 10.0003 1.66602C5.41699 1.66602 1.66699 5.41602 1.66699 9.99935C1.66699 14.5827 5.41699 18.3327 10.0003 18.3327Z" stroke="#E34148" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10 6.66699V10.8337" stroke="#E34148" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.99512 13.333H10.0026" stroke="#E34148" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div>Безопасность платежей обеспечивается Сбербанком. Персональные данные не передаются третьим лицам и защищены в соответствии с законодательством РФ.</div>
            </div>

          </Container>
        </section>
        <FAQSection
          qwestions={user_profile_type == `legal` ? ( ajax_data?.qwestions_ng_legal || [] ) : ( ajax_data?.qwestions_ng || [] )}
        />
      </>
    )
  }
}

Delivery.propTypes = {
  ajax_data: PropTypes.object,
  user_profile_type: PropTypes.string
}